export enum GooogleAnalyticsCategoryType {
  REQUEST = 'request',
  SUCCESS = 'sucesss',
  FAIL = 'fail',
}
export enum GooogleAnalyticsActionType {
  QUOTE = 'quote',
  SHIPMENT = 'shipment',
  LOGIN = 'login',
}
